export default __webpack_public_path__ + "static/media/complete_cover_cropped.67274e08.jpg";